import { render, staticRenderFns } from "./CardAdminCoordinadores.vue?vue&type=template&id=ec302bec&scoped=true"
import script from "./CardAdminCoordinadores.vue?vue&type=script&lang=js"
export * from "./CardAdminCoordinadores.vue?vue&type=script&lang=js"
import style0 from "./CardAdminCoordinadores.vue?vue&type=style&index=0&id=ec302bec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec302bec",
  null
  
)

export default component.exports